// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgCrib = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path d="M13.933 11.159a.665.665 0 0 0-.804.44 2.1 2.1 0 0 1-2.013 1.504h-.147v-1.867a3.068 3.068 0 0 0 2.86-3.05l.027-1.997c0-2.446-2.593-4.59-5.6-4.59a.657.657 0 0 0-.649.649v3.206l-4.753-.078a.77.77 0 0 0-.458.19.622.622 0 0 0-.2.459l-.025 2.16a3.077 3.077 0 0 0 2.86 3.051v1.867h-.146A2.1 2.1 0 0 1 2.87 11.6a.657.657 0 0 0-.804-.441.657.657 0 0 0-.44.812A3.457 3.457 0 0 0 4.884 14.4h6.23a3.457 3.457 0 0 0 3.259-2.429.657.657 0 0 0-.44-.812Zm-5.03-8.22a4.26 4.26 0 0 1 3.553 2.593L8.902 5.42V2.94ZM3.467 8.186l.026-1.496 9.066.138-.026 1.358a1.78 1.78 0 0 1-1.78 1.78H5.247a1.789 1.789 0 0 1-1.78-1.78Zm2.86 3.076h3.345v1.841H6.328v-1.84Z" />
  </svg>
)

export default SvgCrib
